import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "sidebar",
  class: "sidebar sidebar-fixed menu-sidebar",
  "data-simplebar-direction": "vertical"
}
const _hoisted_2 = { class: "sidebar-scroll-content border-radius-20" }
const _hoisted_3 = { class: "nav nav-list background-white" }
const _hoisted_4 = ["id"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  style: {"display":"flex"},
  class: "width100"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "att-submenu" }
const _hoisted_9 = { style: {"display":"flex"} }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 0,
  class: "new-icon"
}
const _hoisted_12 = ["href"]
const _hoisted_13 = { style: {"display":"flex"} }
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  style: {"margin-left":"20px"},
  class: "non-active-menu-color nav-menu-header"
}
const _hoisted_16 = { class: "side-bar-menu-description display-block" }
const _hoisted_17 = { class: "footerbranding" }
const _hoisted_18 = {
  target: "_blank",
  rel: "noreferrer",
  href: "https://ventla.io/"
}
const _hoisted_19 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems.MenuItems, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            id: item.Id,
            key: item.Id,
            class: _normalizeClass(["menu-item", {
            'selected-menu-active-border': (!_ctx.hasSubItems(item) && _ctx.router.name === item.ComponentName) || (_ctx.hasSubItems(item) && _ctx.isSubItemActive(item) && !_ctx.expandedItems[item.Id]),
            'attendance-menu-item': _ctx.hasSubItems(item),
          }])
          }, [
            (_ctx.hasSubItems(item))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    class: _normalizeClass(["attendance-parent-link", { 'selected-menu-active': _ctx.isSubItemActive(item) && !_ctx.expandedItems[item.Id] }]),
                    onClick: ($event: any) => (_ctx.toggleExpand(item.Id))
                  }, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", null, [
                        _createElementVNode("img", {
                          class: "nav-module-icon",
                          src: _ctx.GetImageSrc(item.IconIndex, _ctx.isSubItemActive(item))
                        }, null, 8, _hoisted_7)
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["margin-left-20 nav-menu-header", [_ctx.isSubItemActive(item) ? 'active-menu-color' : 'non-active-menu-color']]),
                        style: {"flex":"1"}
                      }, [
                        _createElementVNode("span", null, _toDisplayString(item.Title), 1),
                        _createElementVNode("small", {
                          class: _normalizeClass(["side-bar-menu-description display-block", {'active-menu-color': _ctx.isSubItemActive(item)}])
                        }, _toDisplayString(item.Description), 3)
                      ], 2),
                      (_openBlock(), _createElementBlock("svg", {
                        class: _normalizeClass(["att-chevron", { 'att-chevron--open': _ctx.expandedItems[item.Id] }]),
                        width: "18",
                        height: "18",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, _cache[0] || (_cache[0] = [
                        _createElementVNode("polyline", { points: "6 9 12 15 18 9" }, null, -1)
                      ]), 2))
                    ])
                  ], 10, _hoisted_5),
                  _withDirectives(_createElementVNode("ul", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.SubItems, (subItem, subIndex) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: subItem.Id,
                        class: _normalizeClass(["att-sub-item", {
                  'att-sub-item-last': subIndex === item.SubItems.length - 1,
                  'selected-menu-active': _ctx.activeComponent === subItem.ComponentName,
                  'selected-menu-active-border': _ctx.activeComponent === subItem.ComponentName,
                }])
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["att-branch", { 'att-branch-last': subIndex === item.SubItems.length - 1 }])
                        }, null, 2),
                        (_openBlock(), _createBlock(_component_router_link, {
                          key: _ctx.$route.fullPath,
                          to: { name: subItem.ComponentName },
                          class: "att-sub-link"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(["display-block", [_ctx.activeComponent === subItem.ComponentName ? 'active-menu-color' : 'non-active-menu-color']])
                            }, _toDisplayString(subItem.Title), 3),
                            _createElementVNode("small", {
                              class: _normalizeClass(["side-bar-menu-description", {'active-menu-color': _ctx.activeComponent === subItem.ComponentName}])
                            }, _toDisplayString(subItem.Description), 3)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      ], 2))
                    }), 128))
                  ], 512), [
                    [_vShow, _ctx.expandedItems[item.Id]]
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (item.IsRouterLink)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: _ctx.$route.fullPath,
                        to: { name: item.ComponentName, params: _ctx.routeParams},
                        class: _normalizeClass({'selected-menu-active': _ctx.activeComponent === item.ComponentName})
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", null, [
                              _createElementVNode("img", {
                                class: "nav-module-icon",
                                src: _ctx.GetImageSrc(item.IconIndex, _ctx.activeComponent === item.ComponentName)
                              }, null, 8, _hoisted_10)
                            ]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["margin-left-20 nav-menu-header", [_ctx.activeComponent === item.ComponentName ? 'active-menu-color' : 'non-active-menu-color']])
                            }, [
                              _createElementVNode("span", null, _toDisplayString(item.Title), 1),
                              (item.Id === 'LMOrgSettings')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t('New')), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("small", {
                                class: _normalizeClass(["side-bar-menu-description display-block", {'active-menu-color': _ctx.activeComponent === item.ComponentName}])
                              }, _toDisplayString(item.Description), 3)
                            ], 2)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["to", "class"]))
                    : (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: _ctx.GetFullExternalUrl(item.Url),
                        class: _normalizeClass({ 'selected-menu-active': _ctx.activeComponent === item.ComponentName })
                      }, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", null, [
                            _createElementVNode("img", {
                              class: "nav-module-icon",
                              src: _ctx.GetImageSrc(item.IconIndex, _ctx.activeComponent === item.ComponentName)
                            }, null, 8, _hoisted_14)
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("span", null, _toDisplayString(item.Title), 1),
                            _createElementVNode("small", _hoisted_16, _toDisplayString(item.Description), 1)
                          ])
                        ])
                      ], 10, _hoisted_12))
                ], 64))
          ], 10, _hoisted_4))
        }), 128))
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("a", _hoisted_18, [
          _createElementVNode("img", {
            class: "footer-img",
            src: _ctx.IconFile
          }, null, 8, _hoisted_19)
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
        _createTextVNode(" © " + _toDisplayString(_ctx.currentYear), 1)
      ])
    ])
  ], 512)), [
    [_vShow, _ctx.showLeftMenuBar]
  ])
}